import React, { useState, useEffect } from 'react';
import { Menu, X, MessageCircle } from 'lucide-react';
import { NAV } from '@/constants/testIds';
import { LOGO_URL } from '@/lib/assets';

const links = [
  { id: 'inicio', label: 'Inicio', testId: NAV.linkInicio },
  { id: 'nosotros', label: 'Nosotros', testId: NAV.linkNosotros },
  { id: 'genetica', label: 'Genética', testId: NAV.linkGenetica },
  { id: 'tecnologia', label: 'Tecnología', testId: NAV.linkTecnologia },
  { id: 'legado', label: 'Legado', testId: NAV.linkLegado },
  { id: 'contacto', label: 'Contacto', testId: NAV.linkContacto },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState('inicio');

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const sections = links.map(l => document.getElementById(l.id)).filter(Boolean);
      const y = window.scrollY + 120;
      for (let i = sections.length - 1; i >= 0; i--) {
        if (sections[i].offsetTop <= y) {
          setActive(sections[i].id);
          break;
        }
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#F5EFE0]/95 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between gap-6">
        <button
          onClick={() => handleClick('inicio')}
          data-testid={NAV.brand}
          className="flex items-center gap-3 group"
        >
          <img
            src={LOGO_URL}
            alt="Agropecuaria Tres Cerritos"
            className={`transition-all duration-300 ${scrolled ? 'h-12' : 'h-16'} w-auto`}
            style={{ mixBlendMode: 'multiply' }}
          />
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testId}
              onClick={() => handleClick(l.id)}
              className={`nav-link font-cinzel text-[12px] tracking-[0.18em] uppercase ${
                active === l.id ? 'text-[#0F3527] active' : 'text-[#0F3527]/70 hover:text-[#0F3527]'
              }`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          onClick={() => handleClick('contacto')}
          data-testid={NAV.ctaContact}
          className="hidden lg:inline-flex btn-whats rounded-full px-5 py-2.5 text-sm font-medium items-center gap-2"
        >
          <MessageCircle size={16} />
          Contáctenos
        </button>

        <button
          className="lg:hidden text-[#0F3527]"
          onClick={() => setOpen((v) => !v)}
          data-testid={NAV.mobileToggle}
          aria-label="Menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden absolute top-full inset-x-0 bg-[#F5EFE0] border-t border-[#0F3527]/10 shadow-lg">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-${l.testId}`}
                onClick={() => handleClick(l.id)}
                className="text-left font-cinzel text-sm tracking-[0.18em] uppercase text-[#0F3527] py-2 border-b border-[#0F3527]/10"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => handleClick('contacto')}
              className="btn-whats rounded-full px-5 py-2.5 text-sm font-medium inline-flex items-center justify-center gap-2 mt-2"
            >
              <MessageCircle size={16} />
              Contáctenos
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
